import React from 'react';

function GeneralSpacing() {
  return (
    <div className="h-24 md:h-32"></div>
  );
}

export default GeneralSpacing;